export const LAM_LOGO_ID = 'LAM-logo_remx1p'
export const FEEDBACK_ICON_ID = 'feedback-icon_mlegrr'

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/lynettearlenemaven/',
} as const
